import { parseEntityItemId } from '@wix/a11y-rules';
import { bulkUpdateSteps } from '@wix/ambassador-online-programs-v3-step/http';
import { assertNotOptional } from '@wix/seo-common-core';
import _ from 'lodash';
import { modify } from 'ricos-content/libs/modify';
import { buildSingleNode } from '../../utils/build-single-rich-content-node';
const BATCH_SIZE = 100;
export const updateOnlineProgramsStepsImages = async (httpClient, errorHandler, altTextData, stepsData) => {
  const {
    withErrorHandler
  } = errorHandler;
  if (!stepsData || !stepsData.imagesToStepMap || !stepsData.steps) {
    return {
      success: false
    };
  }
  const {
    steps
  } = stepsData;
  const updatesByStepId = _.groupBy(altTextData.map(_ref => {
    var _steps$find;
    let {
      id,
      alt
    } = _ref;
    const {
      itemId: imageId,
      entities
    } = parseEntityItemId(id, 2);
    const [stepId, nodeId] = entities;
    return {
      alt,
      entityId: ((_steps$find = steps.find(step => step.id === stepId)) == null ? void 0 : _steps$find.id) ?? '',
      imageId,
      nodeId,
      stepId
    };
  }), upd => upd.entityId);
  const updatedSteps = [];
  Object.entries(updatesByStepId).forEach(_ref2 => {
    let [entityId, updates] = _ref2;
    updatedSteps.push(getUpdateStep(entityId, stepsData, updates));
  });
  const updatedStepsBatches = _.chunk(updatedSteps, BATCH_SIZE);
  const promiseArray = updatedStepsBatches.map(async batch => {
    return withErrorHandler(async () => {
      httpClient.request(bulkUpdateSteps({
        steps: batch
      }));
    }, {
      errorCodesMap: {}
    });
  });
  const results = await Promise.allSettled(promiseArray);
  const isFailed = results.some(result => result.status === 'rejected');
  const allFailedElements = isFailed ? altTextData : [];
  return {
    failedElements: allFailedElements,
    success: !isFailed
  };
};
export const getUpdateStep = (stepId, stepsData, updatesForStep) => {
  var _originalStep$descrip;
  const originalStep = stepsData.stepIdToStepMap.get(stepId);
  const richContentString = originalStep == null || (_originalStep$descrip = originalStep.description) == null ? void 0 : _originalStep$descrip.details;
  assertNotOptional(originalStep);
  assertNotOptional(richContentString);
  const richContent = JSON.parse(richContentString);
  const updatesByNodeId = _.groupBy(updatesForStep, upd => upd.nodeId);
  const updatedRichContent = modify(richContent).filter(node => Object.keys(updatesByNodeId).includes(node.id)).set(node => buildSingleNode(node, updatesByNodeId[node.id]));
  const updatedStep = {
    step: {
      ...originalStep,
      description: {
        ...originalStep.description,
        details: JSON.stringify(updatedRichContent)
      }
    }
  };
  return updatedStep;
};
//# sourceMappingURL=update-online-programs-steps-images.js.map